export default __webpack_public_path__ + "static/img-app-training--mobile-1fc42efd147ec42a7cfe6e31c3472056.jpg";